/**
 * Sanitiza documento (CPF/CNPJ/documento adicional), preservando caracteres alfanuméricos
 * Remove apenas pontuação (pontos, traços, barras, espaços), mantendo letras e números
 * @param {string|null|undefined} document - String do documento com ou sem formatação
 * @returns {string} String com apenas caracteres alfanuméricos (sem pontuação), normalizada para maiúsculas
 */
export const sanitizeDocument = document => {
  if (!document) return "";
  return String(document)
    .replace(/[^a-zA-Z0-9]/g, "")
    .toUpperCase();
};

export default {
  sanitizeDocument
};
